<template>
  <div>
    <el-dialog :visible.sync="showRegister" append-to-body :show-close="false" width="700px" >
      <div class="container">
      <div class="login-panel">
        <div class="input-area">
          <div class="input-row" style="margin-top: 5px">
            <div class="input-header">姓名</div>
            <div class="input-header" style="margin-left: 45px;">性别</div>
          </div>
          <div class="input-row">
            <div class="input-cell">
              <input v-model="name" type="text" placeholder="请输入姓名"/>
            </div>
            <div class="input-cell">
              <input readonly type="text" :value="sexText" placeholder="请选择"/>
              <el-select class="input-invisible" v-model="sex">
                <el-option v-for="(item, index) in sexList" :key="index" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
              <!--            <el-radio-group v-model="sex">-->
              <!--              <el-radio :label="1">男</el-radio>-->
              <!--              <el-radio :label="2">女</el-radio>-->
              <!--            </el-radio-group>-->
            </div>
          </div>
          <div class="input-row">
            <div class="input-header">手机</div>
            <div class="input-header" style="margin-left: 45px;">验证码</div>
          </div>
          <div class="input-row">
            <div class="input-cell">
              <input v-model="mobile" type="text" placeholder="请输入手机"/>
            </div>
            <div class="input-cell">
              <input v-model="captcha" type="text" placeholder="请输入验证码"/>
              <div class="captcha-btn login-btn" :class="{ 'btn-disabled': captchaStatus }">
                <span @click="getCaptcha" v-if="!captchaStatus">发送验证码</span>
                <van-count-down @finish="captchaStatus = false" v-else :time="time">
                  <template v-slot="timeData">
                    <span class="block">{{ timeData.seconds }}</span>
                  </template>
                </van-count-down>
              </div>
            </div>
          </div>
          <div class="input-row">
            <div class="input-header">邮箱</div>
            <div class="input-header" style="margin-left: 45px;">企业名称</div>
          </div>
          <div class="input-row">
            <div class="input-cell">
              <input v-model="email" type="text" placeholder="请输入邮箱"/>
            </div>
            <div class="input-cell">
              <input v-model="company" type="text" placeholder="请输入企业名称"/>
            </div>
          </div>
          <div class="input-row">
            <div class="input-header">部门</div>
            <div class="input-header" style="margin-left: 45px;">职位</div>
          </div>
          <div class="input-row">
            <div class="input-cell">
              <input v-model="department" type="text" placeholder="请输入部门"/>
            </div>
            <div class="input-cell">
              <input v-model="position" type="text" placeholder="请输入职位"/>
            </div>
          </div>
          <div class="input-row">
            <div class="input-header">所属行业</div>
          </div>
          <div class="input-row">
            <div class="input-cell">
              <input v-model="industry" readonly type="text" placeholder="请选择"/>
              <el-select class="input-invisible" v-model="industry">
                <el-option v-for="(item, index) in industryList" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="user-check">
          <div @click="agree = !agree" class="check-box" :class="{ active: agree }"></div>
          <div class="check-text">
            本人同意上述<span @click.stop="showProtocol1 = true">《有关照片、音频和视频录制的条款》</span>及
            <span @click.stop="showProtocol2 = true">《爱德万测试隐私政策（个人信息保护政策）》</span>。
          </div>
        </div>
        <div @click="submit" class="main-btn">
          确定
        </div>
      </div>
      <el-dialog title="有关照片、音频和视频录制的条款" append-to-body :visible.sync="showProtocol1" width="500px">
        <div class="protocol">
          <div>
            &emsp;当您参加爱德万测试(ADVANTEST)的活动时（包括线上活动以及线下活动），您可能
            进入发生拍照、录音和录影的区域。一旦您进入活动会场，即表示您同意爱德万测试及其关
            联公司及其代表将采访内容，摄影、录音、录影以及将其发布、出版、展示或复制用于新闻
            发布、网络广播、营销用途、电视广播、广告、网页内容、社交媒体或任何其他用途。爱德
            万测试可能将图像、照片和/或视频用于宣传今后举办的类似活动，用来突显活动并展示爱
            德万测试的能力。您同意使爱德万测试、其管理者、员工以及每一位和所有相关人员免于承
            担与摄制、录制、数字化或出版以及使用采访内容、摄影、电脑影像、视频和/录音有关的
            任何责任、索赔或者其他权利主张。当您进入活动会场，即表示您同意放弃您可能享有的任
            何主张的一切权利，包括对有关内容的使用、展示、串流传播、网络广播、电视广播或这些
            材料的其他出版收取费用或版税的权利，不论该使用、展示、直播、广播、网络广播或其他
            出版行为的用途。同时您也同意放弃对爱德万测试或爱德万测试指派的人员或单位所拍摄、
            录制的任何相片、影片或录音进行检查或审核。在进入活动会场之前，您已被充分告知您所
            同意的内容、放弃的权利和免除的责任。
          </div>
        </div>
      </el-dialog>
      <PrivateProtocol :visible="showProtocol2" @close="showProtocol2 = false">
      </PrivateProtocol>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import PrivateProtocol from "./components/private-protocol";
import {register, getCaptcha} from "@/api/user";
import industry from "@/utils/industry";
import {setToken} from "@/utils/auth";

export default {
  name: "Register",
  components: {PrivateProtocol},
  data() {
    return {
      showRegister: false,
      sexList: [
        { name: "男", value: 1 },
        { name: "女", value: 2 },
        { name: "其他", value: 3 },
      ],
      redirect: undefined,
      otherQuery: {},
      sex: 1,
      industryList: industry,
      mobile: "",
      industry: "",
      captcha: "",
      email: "",
      company: "",
      position: "",
      name: "",
      department: "",
      time: 60 * 1000,
      captchaStatus: false,
      agree: false,
      showProtocol1: false,
      showProtocol2: false,
      unionid: "",
    };
  },
  computed: {
    sexText() {
      if (this.sex) {
        let text = "";
        this.sexList.forEach((item) => {
          if (item.value == this.sex) {
            text = item.name;
            return;
          }
        });
        return text;
      } else {
        return "";
      }
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          if (query.redirect) {
            this.redirect = decodeURIComponent(query.redirect);
          }
          if (query.unionid) {
            this.unionid = query.unionid;
          }
          if (this.getOtherQuery(query)) {
            this.otherQuery = this.getOtherQuery(query);
          }
        }
      },
      immediate: true,
    },
  },
  created() {
  },
  methods: {
    showRegisterDialog() {
      this.showRegister = true;
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur != "redirect") {
          [cur] = query[cur];
        }
        return acc;
      }, {});
    },
    getCaptcha() {
      getCaptcha({mobile: this.mobile}).then((res) => {
        if (res.code == 200) {
          this.captchaStatus = true;
        }
      });
    },
    submit() {
      if( this.agree === false) {
        console.log('agree',this.agree)
        this.$message({message: "请先勾选下方条款", type: "error",});
      }
      if (this.formCheck() && this.agree === true) {
        let that = this
        try {
          (async () => {
            const res = await register({
              mobile: that.mobile, captcha: that.captcha, sex: that.sex, email: that.email,
              company: that.company, position: that.position, name: that.name,
              industry: that.industry, department: that.department, unionid: that.unionid
            })
            if (res.code == 200) {
              const token = res.data.token
              that.$store.commit("user/SET_TOKEN", token)
              setToken(token)
              await that.$store.dispatch("user/getInfo")
              let path = "/"
              if (that.redirect != undefined) path = that.redirect
              await that.$router.push({path})
              this.showRegister = false
            }
          })()
        } catch (error) {
          console.log(error);
        }
      }
    },
    formCheck() {
      if (!this.mobile) {
        this.$message({message: "请填写手机", type: "error",});
        return false;
      }
      if (!this.department) {
        this.$message({message: "请填写部门", type: "error",});
        return false;
      }
      if (!this.industry) {
        this.$message({message: "请选择行业", type: "error",});
        return false;
      }
      if (!this.captcha) {
        this.$message({message: "请填写验证码", type: "error",});
        return false;
      }
      if (!this.email) {
        this.$message({message: "请填写邮箱", type: "error",});
        return false;
      }
      if (!this.company) {
        this.$message({message: "请填写企业名", type: "error",});
        return false;
      }
      if (!this.position) {
        this.$message({message: "请填写职位", type: "error",});
        return false;
      }
      if (!this.name) {
        this.$message({message: "请填写姓名", type: "error",});
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        this.$message({message: "手机号格式不正确", type: "error",});
        return false;
      }
      if (!/^([a-zA-Z\d])(\w|\-|\.)+@([a-zA-Z\d])(\w|\-)+(\.[a-zA-Z]{1,}){1,}$/.test(this.email)) {
        this.$message({message: "邮箱格式不正确", type: "error",});
        return false;
      }
      if (this.position.length < 2) {
        this.$message({message: "职位内容过短", type: "error",});
        return false;
      }
      if (this.company.length < 2) {
        this.$message({message: "企业名称过短", type: "error",});
        return false;
      }
      if (this.department.length < 2) {
        this.$message({message: "部门名称不能小于2位数", type: "error",});
        return false;
      }
      if (this.name.length < 2) {
        this.$message({message: "姓名过短", type: "error",});
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -60px;
  .login-panel {
    background: rgb(219, 236, 217);
    padding: 0px 0px;
    width: 700px;
    //border: 1.5px solid rgb(247, 247, 246);
    border-radius: 10px;

    .main-text {
      border-bottom: 1px solid #f0f0f0;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    .input-row {
      display: flex;
      justify-content: space-between;
      margin: 0px 30px;

      .input-header {
        width: 50%;
        font-size: 16px;
        margin-right: 19px;
        text-align: left;
        height: 16px;
        line-height: 15px;
        font-weight: 500;
        color: black;
        span {
          color: red;
        }
      }

      .input-cell {
        display: flex;
        position: relative;
        align-items: center;
        margin: 15px 0px;

        .input-invisible {
          position: absolute;
          left: 0px;
          z-index: 2;
          opacity: 0;
        }


      }

      .captcha-btn {
        height: 40px;
        position: absolute;
        bottom: 0;
        right: 0;
        border-radius: 5px;
        width: 86px;
        background: rgb(41, 116, 66);
        font-size: 12px;
        color: #fff;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }

      .btn-disabled {
        background: rgb(76, 153, 101);

        .block {
          height: 100%;
          color: #fff;
          line-height: 40px;
        }
      }

      input {
        height: 40px;
        background: rgb(255, 255, 255);
        border: 1.5px solid rgb(41, 116, 66);
        border-radius: 5px;
        width: 280px;
        padding: 0 10px;
        font-size: 14px;
        box-sizing: border-box;
      }
    }

    .user-check {
      display: flex;
      width: 100%;
      padding: 20px 30px 0;
      box-sizing: border-box;
      font-size: 12px;
      .check-box {
        margin-top: 0px;
        background: rgb(219, 236, 217);
        border: 1px solid rgb(0, 0, 0);
        border-radius: 1px;
        margin-right: 5px;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }

      .active {
        background: rgb(41, 116, 66);
      }

      .check-text {
        // width: calc(100% - 0.42rem);
        font-size: 12px;
        color: #444444;

        span {
          cursor: pointer;
          color: rgb(41, 116, 66);
          text-decoration: underline;
        }
      }
    }

    .main-btn {
      cursor: pointer;
      height: 30px;
      width: 76px;
      background: rgb(41, 116, 66);
      border-radius: 10px;
      color: #fff;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      margin: 3px auto 3px;
    }
  }

  .protocol {
    font-size: 14px;
    line-height: 30px;
    word-break: break-all;

    .font-bold {
      font-weight: bold;
    }
  }
}
</style>
